import { EpimsBaseEntityDto } from './epim-base.dto';
export class VendorDto extends EpimsBaseEntityDto {
    Surname: string;
    FirstName: string;
    MiddleName: string;
    VenAddress: string;
    VenPhoneNo: string;
    VenEmailAddress: string;
    VenDoB: Date;
    ContractorId: string;
    FullName: string;
    IsADamagedClerk: string;
    AccessLink: string;
    length;
}